var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 167,
    viewBox: "0 0 196 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6505 83.1007C19.5422 83.4236 19.1926 83.5976 18.8697 83.4894L6.08158 79.2016C5.75863 79.0933 5.58461 78.7437 5.6929 78.4208C5.80118 78.0978 6.15076 77.9238 6.47371 78.0321L19.2618 82.3199C19.5848 82.4282 19.7588 82.7777 19.6505 83.1007Z",
    fill: "#FFD204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.414 143.065C103.718 142.913 104.089 143.036 104.241 143.341L110.282 155.4C110.435 155.704 110.312 156.075 110.007 156.227C109.703 156.38 109.332 156.257 109.18 155.952L103.138 143.893C102.986 143.588 103.109 143.218 103.414 143.065Z",
    fill: "#FFD204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.159 0.0102868C155.494 0.0719138 155.716 0.39344 155.654 0.728435L153.214 13.9937C153.152 14.3286 152.831 14.5503 152.496 14.4886C152.161 14.427 151.939 14.1055 152.001 13.7705L154.441 0.505264C154.503 0.170269 154.824 -0.0513401 155.159 0.0102868Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.689 24.909C182.532 24.6066 182.65 24.2344 182.953 24.0777L194.927 17.8704C195.23 17.7137 195.602 17.8317 195.759 18.1341C195.915 18.4365 195.797 18.8088 195.495 18.9655L183.52 25.1728C183.218 25.3295 182.846 25.2114 182.689 24.909Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6568 166.593C46.349 166.448 46.2177 166.08 46.3636 165.772L55.0603 147.423C55.2062 147.115 55.574 146.984 55.8818 147.13C56.1896 147.276 56.3209 147.643 56.175 147.951L47.4782 166.3C47.3323 166.608 46.9646 166.739 46.6568 166.593Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.137 143.159C158.353 142.896 158.742 142.858 159.005 143.075L169.419 151.646C169.682 151.862 169.72 152.251 169.504 152.514C169.287 152.777 168.898 152.814 168.635 152.598L158.221 144.027C157.958 143.81 157.92 143.422 158.137 143.159Z",
    fill: "#FFD204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8718 29.205C27.0882 28.942 27.4769 28.9042 27.7399 29.1207L38.1542 37.6918C38.4172 37.9083 38.4549 38.2969 38.2384 38.5599C38.022 38.8229 37.6333 38.8607 37.3703 38.6442L26.9561 30.0731C26.6931 29.8566 26.6553 29.468 26.8718 29.205Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.478 87.3647C174.781 85.6872 172.856 84.8923 171.178 85.5893L161.665 89.5418C161.18 89.7434 160.623 89.5135 160.422 89.0283C160.22 88.5431 160.45 87.9863 160.935 87.7847L170.448 83.8322C172.126 83.1352 172.921 81.2102 172.224 79.5326L168.271 70.0195C168.07 69.5343 168.3 68.9775 168.785 68.7759C169.27 68.5743 169.827 68.8042 170.028 69.2894L173.981 78.8025C174.678 80.4801 176.603 81.275 178.281 80.578L187.794 76.6255C188.279 76.4239 188.836 76.6538 189.037 77.139C189.239 77.6242 189.009 78.1809 188.524 78.3825L179.011 82.3351C177.333 83.0321 176.538 84.9571 177.235 86.6347L181.188 96.1478C181.389 96.633 181.159 97.1898 180.674 97.3913C180.189 97.5929 179.632 97.363 179.431 96.8778L175.478 87.3647Z",
    fill: "url(#paint0_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06092 50.03C8.36391 48.3524 6.43891 47.5575 4.76133 48.2545L0.896105 49.8605C0.629244 49.9714 0.323027 49.8449 0.21215 49.5781C0.101273 49.3112 0.227723 49.005 0.494583 48.8941L4.35981 47.2881C6.03739 46.5911 6.8323 44.6661 6.13529 42.9886L4.52934 39.1233C4.41846 38.8565 4.54491 38.5503 4.81177 38.4394C5.07863 38.3285 5.38485 38.4549 5.49572 38.7218L7.10168 42.587C7.79869 44.2646 9.72368 45.0595 11.4013 44.3625L15.2665 42.7566C15.5334 42.6457 15.8396 42.7721 15.9504 43.039C16.0613 43.3059 15.9349 43.6121 15.668 43.7229L11.8028 45.3289C10.1252 46.0259 9.33029 47.9509 10.0273 49.6285L11.6333 53.4937C11.7441 53.7606 11.6177 54.0668 11.3508 54.1777C11.084 54.2886 10.7778 54.1621 10.6669 53.8952L9.06092 50.03Z",
    fill: "url(#paint1_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4705 151.939C82.8426 151.132 80.8693 151.799 80.0631 153.426L78.5496 156.483C78.4346 156.715 78.1533 156.81 77.9212 156.695C77.6891 156.58 77.5941 156.298 77.709 156.066L79.2226 153.01C80.0288 151.382 79.3627 149.409 77.7348 148.603L74.6786 147.089C74.4465 146.974 74.3515 146.693 74.4665 146.461C74.5814 146.229 74.8628 146.134 75.0949 146.249L78.151 147.762C79.7789 148.568 81.7522 147.902 82.5584 146.274L84.072 143.218C84.1869 142.986 84.4683 142.891 84.7004 143.006C84.9325 143.121 85.0274 143.402 84.9125 143.635L83.3989 146.691C82.5927 148.319 83.2589 150.292 84.8868 151.098L87.9429 152.612C88.175 152.727 88.27 153.008 88.155 153.24C88.0401 153.472 87.7587 153.567 87.5266 153.452L84.4705 151.939Z",
    fill: "url(#paint2_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7056 144.044C31.0829 144.044 28.8376 143.111 26.9699 141.243C25.1022 139.375 24.1683 137.13 24.1683 134.507C24.1683 131.884 25.1022 129.639 26.9699 127.771C28.8376 125.904 31.0829 124.97 33.7056 124.97C36.3284 124.97 38.5736 125.904 40.4414 127.771C42.3091 129.639 43.243 131.884 43.243 134.507C43.243 137.13 42.3091 139.375 40.4414 141.243C38.5736 143.111 36.3284 144.044 33.7056 144.044ZM33.7084 141.819C35.72 141.819 37.4411 141.103 38.8717 139.67C40.3023 138.238 41.0176 136.516 41.0176 134.504C41.0176 132.493 40.3013 130.772 38.8689 129.341C37.4364 127.91 35.7144 127.195 33.7028 127.195C31.6913 127.195 29.9702 127.911 28.5396 129.344C27.109 130.776 26.3937 132.498 26.3937 134.51C26.3937 136.521 27.1099 138.243 28.5424 139.673C29.9749 141.104 31.6969 141.819 33.7084 141.819Z",
    fill: "url(#paint3_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0314 37.2583C60.72 37.2583 59.5974 36.7913 58.6636 35.8575C57.7297 34.9236 57.2628 33.801 57.2628 32.4896C57.2628 31.1782 57.7297 30.0556 58.6636 29.1217C59.5974 28.1879 60.72 27.721 62.0314 27.721C63.3428 27.721 64.4654 28.1879 65.3993 29.1217C66.3332 30.0556 66.8001 31.1782 66.8001 32.4896C66.8001 33.801 66.3332 34.9236 65.3993 35.8575C64.4654 36.7913 63.3428 37.2583 62.0314 37.2583ZM62.0328 36.1456C63.0386 36.1456 63.8992 35.7875 64.6144 35.0713C65.3298 34.355 65.6874 33.494 65.6874 32.4882C65.6874 31.4824 65.3293 30.6219 64.6131 29.9066C63.8968 29.1913 63.0358 28.8336 62.03 28.8336C61.0242 28.8336 60.1637 29.1918 59.4484 29.908C58.7331 30.6242 58.3754 31.4852 58.3754 32.491C58.3754 33.4968 58.7336 34.3573 59.4498 35.0726C60.166 35.7879 61.0271 36.1456 62.0328 36.1456Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.978 128.617C135.428 128.617 134.957 128.421 134.565 128.029C134.174 127.638 133.978 127.167 133.978 126.617C133.978 126.067 134.174 125.596 134.565 125.204C134.957 124.813 135.428 124.617 135.978 124.617C136.528 124.617 136.999 124.813 137.39 125.204C137.782 125.596 137.978 126.067 137.978 126.617C137.978 127.167 137.782 127.638 137.39 128.029C136.999 128.421 136.528 128.617 135.978 128.617Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5769 10.6166C88.1644 10.6166 87.8113 10.4697 87.5175 10.176C87.2238 9.88223 87.0769 9.52911 87.0769 9.11661C87.0769 8.70411 87.2238 8.35098 87.5175 8.05723C87.8113 7.76348 88.1644 7.61661 88.5769 7.61661C88.9894 7.61661 89.3425 7.76348 89.6363 8.05723C89.93 8.35098 90.0769 8.70411 90.0769 9.11661C90.0769 9.52911 89.93 9.88223 89.6363 10.176C89.3425 10.4697 88.9894 10.6166 88.5769 10.6166Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4778 60.6168C44.0653 60.6168 43.7122 60.47 43.4185 60.1762C43.1247 59.8825 42.9778 59.5293 42.9778 59.1168C42.9778 58.7043 43.1247 58.3512 43.4185 58.0575C43.7122 57.7637 44.0653 57.6168 44.4778 57.6168C44.8903 57.6168 45.2435 57.7637 45.5372 58.0575C45.831 58.3512 45.9778 58.7043 45.9778 59.1168C45.9778 59.5293 45.831 59.8825 45.5372 60.1762C45.2435 60.47 44.8903 60.6168 44.4778 60.6168Z",
    fill: "#6D6D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4778 127.617C10.0653 127.617 9.71222 127.47 9.41847 127.176C9.12472 126.882 8.97784 126.529 8.97784 126.117C8.97784 125.704 9.12472 125.351 9.41847 125.057C9.71222 124.764 10.0653 124.617 10.4778 124.617C10.8903 124.617 11.2435 124.764 11.5372 125.057C11.831 125.351 11.9778 125.704 11.9778 126.117C11.9778 126.529 11.831 126.882 11.5372 127.176C11.2435 127.47 10.8903 127.617 10.4778 127.617Z",
    fill: "url(#paint4_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94 65.3484C184.05 65.3484 183.288 65.0315 182.654 64.3977C182.021 63.7638 181.704 63.0019 181.704 62.1118C181.704 61.2218 182.021 60.4598 182.654 59.826C183.288 59.1922 184.05 58.8752 184.94 58.8752C185.83 58.8752 186.592 59.1922 187.226 59.826C187.86 60.4598 188.177 61.2218 188.177 62.1118C188.177 63.0019 187.86 63.7638 187.226 64.3977C186.592 65.0315 185.83 65.3484 184.94 65.3484ZM184.941 64.5932C185.624 64.5932 186.208 64.3501 186.693 63.864C187.179 63.3779 187.422 62.7935 187.422 62.1109C187.422 61.4282 187.179 60.8442 186.693 60.3587C186.206 59.8732 185.622 59.6304 184.939 59.6304C184.257 59.6304 183.673 59.8735 183.187 60.3596C182.702 60.8457 182.459 61.4301 182.459 62.1128C182.459 62.7954 182.702 63.3795 183.188 63.865C183.674 64.3505 184.259 64.5932 184.941 64.5932Z",
    fill: "url(#paint5_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.214 22.09C112.324 22.09 111.562 21.7731 110.929 21.1393C110.295 20.5054 109.978 19.7435 109.978 18.8534C109.978 17.9634 110.295 17.2014 110.929 16.5676C111.562 15.9338 112.324 15.6168 113.214 15.6168C114.104 15.6168 114.866 15.9338 115.5 16.5676C116.134 17.2014 116.451 17.9634 116.451 18.8534C116.451 19.7435 116.134 20.5054 115.5 21.1393C114.866 21.7731 114.104 22.09 113.214 22.09ZM113.215 21.3348C113.898 21.3348 114.482 21.0918 114.968 20.6056C115.453 20.1195 115.696 19.5351 115.696 18.8525C115.696 18.1698 115.453 17.5858 114.967 17.1003C114.48 16.6148 113.896 16.3721 113.213 16.3721C112.531 16.3721 111.947 16.6151 111.461 17.1012C110.976 17.5874 110.733 18.1717 110.733 18.8544C110.733 19.537 110.976 20.1211 111.462 20.6066C111.948 21.0921 112.533 21.3348 113.215 21.3348Z",
    fill: "url(#paint6_radial_44_1909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.211 115.6L153.438 41.0327C154.26 40.2066 155.229 39.7664 156.343 39.7121C157.457 39.6577 158.48 40.0979 159.41 41.0327C160.341 41.9673 160.806 42.9753 160.806 44.0568C160.806 45.1382 160.341 46.1462 159.41 47.0808L83.982 122.904C82.6189 124.273 81.0285 124.958 79.211 124.958C77.3935 124.958 75.8031 124.273 74.44 122.904L40.3122 88.6195C39.49 87.7935 39.06 86.8126 39.0221 85.6768C38.9842 84.5411 39.4304 83.506 40.3609 82.5714C41.2914 81.6366 42.2949 81.1692 43.3714 81.1692C44.4477 81.1692 45.4512 81.6366 46.3817 82.5714L79.211 115.6Z",
    fill: "url(#paint7_radial_44_1909)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_44_1909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.19 71.6169) rotate(48.9909) scale(60.959 168.381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#80CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD204"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIllustration);
export default __webpack_public_path__ + "static/media/success-illustration.1b63cb9ebe3af626421f07545d933ee9.svg";
export { ForwardRef as ReactComponent };